import React from 'react';
import { Routes, Route } from 'react-router-dom';

import { WithAdminMode } from 'src/helpers/hocs/withAdminMode';
import { WithClientMode } from 'src/helpers/hocs/withClientMode';

import { NotFound } from './components/Errors/NotFound';
import paths from './navigation/paths';
import Home from './components/Home';
import { ReviewNotFound } from './components/Errors/ReviewNotFound';
import ReviewsCatalog from './components/ReviewsCatalog';

function App() {
    return (
        <div className='App'>
            <div className='main'>
                <WithAdminMode>
                    <Routes>
                        <Route path={`${paths.home}`} element={<Home />} />
                        <Route path={paths.reviewCatalog} element={<ReviewsCatalog />}>
                            <Route path={`${paths.reviewCatalog}/*`} element={<ReviewsCatalog />} />
                        </Route>
                        <Route path='*' element={<NotFound />} />
                    </Routes>
                </WithAdminMode>
                <WithClientMode>
                    <Routes>
                        <Route path={`${paths.reviewCatalog}/*`} element={<ReviewsCatalog />} />
                        <Route path='*' element={<ReviewNotFound />} />
                    </Routes>
                </WithClientMode>
            </div>
        </div>
    );
}

export default App;
